module.exports = __webpack_public_path__ + "fonts/iconfont.6e4c87d.ttf";